import { useState } from 'react';
import { createStore } from 'reusable';

export const useIsChangePasswordOpen = createStore(() => useState(false));

export const useIsForgotPasswordOpen = createStore(() => useState(false));

export const useIsResetPasswordModalOpen = createStore(() => useState(false));
